module.exports = __webpack_public_path__ + "static/media/06B2.115bbc29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/06B2.png
// module id = 272
// module chunks = 0